import React, { useState } from 'react';

import { Button } from '@/components/shadcn-ui/button';
import { generateAuthUrl } from '@/network/auth.service';

const AuthPage = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { data } = await generateAuthUrl({
      type: 'login',
      grantType: 'sms-otp',
    });

    if (data?.success && data.data?.authUrl) {
      window.location.href = data.data?.authUrl;
    } else {
      alert('Auth Url not received');
    }
    setIsLoading(false);
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-muted py-16">
      <section className="flex flex-col justify-center rounded-xl border border-border bg-card p-8 shadow-md md:p-12">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold text-primary">Welcome Back</h1>
          <p className="text-muted-foreground">Sign in to your account</p>
        </div>

        <Button className="" onClick={handleClick} disabled={isLoading}>
          SMS OTP
        </Button>
      </section>
    </div>
  );
};

export default AuthPage;
